var orderViewModel = (function () {
    var defaultViewModel = {
        store: {
            id: null,
            storeNumber: null,
            satelliteNumber: null,
            address: null,
            address1: null,
            address3: null,
            languageCode: null,
            countryCode: null,
            storeCountry: null,
            maxProteinsForExpressOrder: null,
            storeMainItemsThreshold: null,
            storeSubItemsThreshold: null
        },
        selectedStoreId: null,
        defaultStoreDetails: {},
        kidsMealData: {
        },
        isShowupdatePhoneNumberModal: true,
        promoCode: {},
        promosAndDeals: {
            isPromoCodeApplied: false
        },
        promoDetails: {},
        showModalId: '',
        favStore: {
            id: null,
            storeNumber: null,
            satelliteNumber: null,
            address: null,
            address1: null,
            address3: null,
            languageCode: null,
            countryCode: null
        },
        topNav: {
            newDisplayText: null,
            defaultDisplayText: null,
            defaultUrl: null
        },
        smartBanner: {
            hasSeen: false
        },
        currentOrder: {
            cartId: null,
            cartQuantity: 0,
            animationForCartQty: false,
            TotalcartQuantity: 0,
            product: {
                productId: null,
                options: [],
                MasterProductID: 0,
                CategoryID: 0,
                Price: 0
            },
            offers: {
                Applied: false,
                OfferId: null,
                IsPromoOfferID: false,
                OfferDescription: null,
                DiscountAmount: null
            }
        },
        Rewards: {
            appliedList: [],
            notAppliedList: []
        },
        combo: {
            id: null,
            name: null,
            value: null,
            cartItemId: null,
            options: []
        },
        ScContext: {
            id: null,
            itemTemplateID: null,
        },
        ScTemplate: {
            productTemplateID: null,
            customizerTemplateID: null,
            restaurantTemplateID: null
        },
        ScPage: {
            orderManagement: null
        },
        Analytics: {
            isFooterMIAMSelected: false,
            isMiamYesButtonClicked: false,
            isMiamFromCart: false,
            isMiamFromCustomizer: false,
            isExtrasFromCustomizer: false,
            isNoMiamFromCustomizer: false,
            signupSource: null,
            guestCountry: "",
            isRecentLocation: false,
            orderType: "",
            CategoryName: "",
            ProductName: "",
            tierLevel: "",
            subClubTierLevel:"",
            tierCode: "",
            restaurantSelected: 0,
            pickup: 0,
        },
        pdpAnalytics: {
            ingredients: null,
            props: null,
            quantity: null,
            price: null,
            miamPrice: null
        },
        Payments: {
            storedSubwayPayments: null,
            paypalBannerClose: false
        },
        DeliveryAddress:
        {
            StreetAddressLine1: null,
            StreetAddressLine2: null,
            City: null,
            State: null,
            Zip: null,
            Country: null,
            DirectDelivery: false,
            QuoteId: null
        },
        addressData:
        {
            StreetAddressLine1: null,
            StreetAddressLine2: null,
            City: null,
            State: null,
            Zip: null,
            Country: null,
            SiteName: null,
        },
        Preferences:
        {
            Type: null,
            Value: null
        },
        selectedCombo: {
            comboId: null,
            productId: null
        },
        sandwichCustomized: false,
        comboSourceUpsell: false,
        pdpComboSource: '',
        OrderSourceType: '',
        comboEditClick: false,
        hasLoggedIn: false,
        hasDeliveryLocator: undefined,
        hasCurbside: false,
        hasCurbsideBeforeHours: false,
        curbsideAvailableMessage: null,
        scheduleCurbsideMessage: null,
        orderType: null,
        AnalyticsorderType: null,
        historicalOrders: [], //Cart Item ID only
        favoriteOrders: [], //Track cart ID, name, [item name, options]
        favoriteItems: [],
        favoriteItemCount: 0,
        selectedOffer: null,
        cartProducts: [],
        analyticsCartProducts: [],
        RecentOrdersCartID: null,
        IsRecentOrder: false,
        IsRecentOrdersPage: false,
        IsDeliveryStoreClosed: false,
        makeitamealPrice: '',
        makeItaMealName: '',
        lastOrderData: null,
        headerFooter: [],
        headerFooterLanguageCode: null,
        IsRecentOrderAddToCart: false,
        IsOrderAgainAddToCart: false,
        addToBagLineItem: false,
        maintainCartAddressClick: false,
        upsellProducts: [],
        upsellProductPayloads: [],
        orderNowDashboardClick: false,
        cartItemId: [],
        bundleItemId: [],
        orderStatusClicked: false,
        showRedirectSuccessBanner: false,
        redirectBannerMessage: '',
        removeAndContinueMaintainCart: false,
        removeItemFromCartBtn: false,
        subCategory: '',
        categoryDisplayName: '',
        orderInprogressOneTimeshow: [],
        tempRecentProductDetails: null,
        targetlocator: null,
        calledCreateCart: false,
        storeStatus: null,
        comboSource: null,
        isFavoriteOrder: false,
        selectedCategory: null,
        EmailOptInProfile: null,
        LoyaltyOption: null,
        offerCardType: '',
        defaultGray: true,
        itemPromotionAnalytics: '',
        analyticsStoreStatus: 'n/a',
        participatingLocationObject: {
            offerId: null,
            propositionGuid: null,
            PromoCode: null
        },
        loyaltyHistoryErrorMsg: false,
        redeemedOffers: [],
        pdpDefaultCategory: [],
        isNavigateCombo: false,
        comboMasterPromotionID: "",
        isApplyCombo: false,
        currentDateSelected: '',
        lastOrderFulfillmentType: '',
        switchDeliveryAddress: {
            StreetAddressLine1: null,
            StreetAddressLine2: null,
            City: null,
            State: null,
            Zip: null,
            Country: null,
            DirectDelivery: false,
            QuoteId: null,
        },
        LanguagePreferences: null,
    };

    var vm = {};

    var vmKey = 'remoteOrderViewModel';

    var query_string_paramter = window.location.href.split("?")[1];
    const urlParams = new URLSearchParams(query_string_paramter);
    void 0;
    if (urlParams.has('ordexp')) {
        var voidStatus = urlParams.get('ordexp');
        if (voidStatus === 'true') {
            sessionStorage.removeItem(vmKey);
        }
    }
    var keyData = sessionStorage.getItem(vmKey);
    var storedModel = subwayScript.ParseJsonOrDefault(keyData) || {};

    defaultViewModel.key = vmKey;

    //Apply any persisted data and fill in with defaults
    $.extend(vm, defaultViewModel, storedModel);

    vm.save = function () {
        var serializedModel = JSON.stringify(vm);

        sessionStorage.setItem(vmKey, serializedModel);
        setDropdownLanguage();
    };

    vm.update = function (updateFn) {
        updateFn();
        vm.save();
    };

    vm.hasHistoricalOrders = function () {
        return vm.historicalOrders.length > 0;
    };

    vm.hasFavoriteOrders = function () {
        return vm.favoriteOrders.length > 0;
    };

    vm.hasFavoriteItems = function () {
        return vm.favoriteItems.length > 0;
    };
    vm.hasCombo = function () {
        if (vm.combo !== null) {
            if (vm.combo.options !== null) {
                return vm.combo.options.length > 0;
            }
            else if (vm.combo.items !== null) {
                vm.combo.options = vm.combo.items;
                return vm.combo.options.length > 0;
            }
            return false;
        }
    };
    vm.initCombo = function (comboId, comboName, comboValue) {
        if (vm.combo !== null) {
            vm.combo.id = comboId;
            vm.combo.name = comboName;
            vm.combo.value = comboValue;
        }
    };

    vm.addComboOption = function (comboOptionId, comboOptionValue, comboOptionQuantity, comboOptionName, productId, productName) {
        if (vm.combo !== null) {
            var comboOption = {
                id: comboOptionId,
                value: comboOptionValue,
                quantity: comboOptionQuantity,
                name: comboOptionName,
                productid: productId,
                productname: productName
            };
            vm.combo.options.push(comboOption);
        }
    };

    vm.deleteCombos = function () {
        if (vm.combo !== null) {
            vm.combo.id = null;
            vm.combo.name = null;
            vm.combo.value = null;
            vm.combo.cartItemId = null;
            vm.combo.options = [];
        }
    };


    vm.updateCartQuantity = function () {

        var quantity = 0;
        var countMeal = $('#cart').text();
        if (countMeal === undefined || countMeal === "") {
            quantity = 0;
            quantity = quantity + 1;
        }
        else {
            quantity = vm.currentOrder.cartQuantity;
            quantity = (+quantity) + (+countMeal);
        }
        vm.currentOrder.cartQuantity = quantity;
        vm.save();
    };
    vm.Option = function (id, val, price, extrasFromCustomizer, name) {
        this.id = id;
        this.value = val;
        this.price = price;
        this.extrasFromCustomizer = extrasFromCustomizer;
        this.name = name;
    };

    vm.addProductOption = function (id, val, price, extrasFromCustomizer, name) {
        var opt = new vm.Option(id, val, price, extrasFromCustomizer, name);

        vm.currentOrder.product.options.push(opt);
    };
    vm.Upselloption = function (id, val, price, extrasFromCustomizer, name) {
        this.id = id;
        this.value = val;
        this.price = price;
        this.extrasFromCustomizer = extrasFromCustomizer;
        this.name = name;
    };
    vm.addUpsellProductOption = function (id, val, price, extrasFromCustomizer, name) {
        var opt = new vm.Upselloption(id, val, price, extrasFromCustomizer, name);

        vm.currentOrder.product.options.push(opt);
    };

    vm.clearProductOptions = function () { vm.currentOrder.product.options = []; };

    vm.removeProductOption = function (id) {
        var idx = _.findIndex(vm.currentOrder.product.options, function (o) { return parseInt(o.id) === parseInt(id); });

        if (idx === -1) {
            return;
        }

        vm.currentOrder.product.options.splice(idx, 1);
    };

    vm.flushCart = function () {
        vm.currentOrder.cartId = null;
        vm.currentOrder.cartQuantity = 0;
        vm.currentOrder.offers = {};
        vm.currentOrder.sidesDrinksQuantity = 0;
        vm.currentOrder.product.productId = null;
        vm.currentOrder.product.options = [];
        vm.currentOrder.itemAddedtoBag = 0;
        delete vm.currentOrder.productName;
        vm.cartProducts = [];
        vm.anlyticsCartProducts = [];
        vm.save();
    };

    vm.flushCartExceptCartId = function () {
        vm.currentOrder.cartQuantity = 0;
        vm.currentOrder.offers = {};
        vm.currentOrder.sidesDrinksQuantity = 0;
        vm.currentOrder.product.productId = null;
        vm.currentOrder.product.options = [];
        vm.currentOrder.itemAddedtoBag = 0;
        delete vm.currentOrder.productName;
        vm.cartProducts = [];
        vm.anlyticsCartProducts = [];
        vm.save();
    };
    vm.hasProductOption = function (id) {
        var idx = _.findIndex(vm.currentOrder.product.options, function (o) { return o.id === id; });

        return idx !== -1;
    };

    vm.cartCurrentProduct = function (cartItemId, productId, categoryId, MasterProductId) {
        this.cartItemId = cartItemId;
        this.productId = productId;
        this.categoryId = categoryId;
        this.MasterProductId = MasterProductId;
    };
    vm.analyticsCartCurrentProducts = function (categoryId, productId, categoryName, productName) {
        this.categoryId = categoryId;
        this.categoryName = categoryName;
        this.productId = productId;
        this.productName = productName;
    };
    vm.addAnalyticsCartProducts = function (categoryId, productId, categoryName, productName) {
        var index = vm.analyticsCartProducts.findIndex((product) => product.productId === productId && product.categoryId === categoryId);
        if (index === -1) {
            var analyticsCurrentProduct = new vm.analyticsCartCurrentProducts(categoryId, productId, categoryName, productName);
            vm.analyticsCartProducts.push(analyticsCurrentProduct);
        }
    };
    vm.addCartProducts = function (cartItemId, productId, categoryId, MasterProductId) {
        var currentProduct = new vm.cartCurrentProduct(cartItemId, productId, categoryId, MasterProductId);
        vm.cartProducts.push(currentProduct);
    };
    return vm;
})();

analytics.setStoreIsoCodes();
analytics.checkLoginHistory();
analytics.setStoreID();

$(function () {
    $('a[href*="logout"]').click(function () {
        sessionStorage.clear();
    });
    $('a[href*="Logout"]').click(function () {
        sessionStorage.clear();
    });
});
